import { type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { type Observable } from 'rxjs';

export function timezoneInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (!/\/api\/v1\//i.test(request.url)) {
    return next(request);
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return next(request.clone({ setHeaders: { 'Local-Timezone': timeZone } }));
}
